//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "index",
  data: function data() {
    return {
      username: '测试',
      password: '测试',
      radio: '1'
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      this.$router.push({
        name: 'appointment'
      });
    },
    toDetail: function toDetail() {
      this.$router.push({
        name: 'package'
      });
    }
  }
};